<div class="training-popover" *ngIf="config">
  <div class="training-popover-header pt-10 training-popover-section">
    <span class="content-title">
      {{ 'TOOLBAR.CURRENT_TRAINING_LABEL' | translate }}
    </span>
    <a [href]="TASK_LIST_URL" class="training-title" [target]="anchorTarget">
      {{ config.title }}
    </a>
  </div>
  <mat-divider></mat-divider>
  <div class="training-popover-section training-popover-user">
    <div class="content-title">
      {{ 'TOOLBAR.TRAINING_RAISED_BY_LABEL' | translate }}
    </div>
    <q9-user-info [user]="config.raisedBy"></q9-user-info>
  </div>
  <mat-divider></mat-divider>

  <ng-container *ngIf="diagramHistory?.comment?.length">
    <div class="training-popover-section related-trainings">
      <span class="q9-label">
        {{ 'TOOLBAR.TRAINING_INFO_COMMENT_LABEL' | translate }}
      </span>
      <span class="q9-section-data">
        {{ diagramHistory.comment | interpolate }}
      </span>
    </div>
    <mat-divider></mat-divider>
  </ng-container>

  <ng-container *ngIf="config?.hint?.tasks?.length">
    <div class="training-popover-section related-trainings">
      <div>
        <span class="q9-label">{{ 'TOOLBAR.RELATED_TRAININGS_LABEL' | translate }}:</span>
        <div *ngFor="let task of config.hint.tasks">
          <span class="q9-section-data">
            {{ task.title }}
          </span>
          <span class="q9-label">
            {{ 'TOOLBAR.TRAINING_RAISED_BY_ITEM' | translate }}:
            {{ task.raisedBy | transform: getFullName }}
          </span>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="training-popover-section overlap-reason">
      <span class="q9-section-data">
        {{ 'TOOLBAR.TRAINING_OVERLAP_REASON' | translate }}
      </span>
    </div>
  </ng-container>
</div>
